import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { getHumanizedPast } from 'app/helpers/momentHelper';
import { TranslateService } from '@ngx-translate/core';
import { APIService } from 'app/services/api.service';
import { map, Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PosOrganizationModel } from 'app/reducers/pos.reducer';
import { Store } from '@ngrx/store';
import { selectHasPermission } from 'app/reducers/context.selectors';
import { PermissionCode } from 'app/helpers/permission-codes';
import * as MenuSelectors from 'app/reducers/menu.selectors';
import { MenuService } from 'app/services/menu.service';
import * as MenuActions from 'app/reducers/menu.actions';

@UntilDestroy()
@Component({
  selector: 'app-menu-sync-card',
  templateUrl: './menu-sync-card.component.html',
  styleUrls: ['./menu-sync-card.component.scss']
})
export class MenuSyncCardComponent implements OnInit, OnChanges {

  @Input() serviceName: string;
  @Input() lastSync: Date;
  @Input() pipeId: string;
  @Input() collapsed?: boolean;

  past: string;
  isLoading: boolean;
  error: string;
  menuOrganization: PosOrganizationModel;
  menuOrganization$;

  // Право IC-2972: ручная выгрузка меню.
  hasMenuUpload$: Observable<boolean> = this.store.select(selectHasPermission(PermissionCode.MenuUpload));

  constructor(
    private translate: TranslateService,
    private api: APIService,
    private store: Store,
    private menuService: MenuService,
  ) {
  }

  ngOnInit(): void {
    this.menuOrganization$ = this.store.select(MenuSelectors.selectMenuOrganization);
    this.store.select(MenuSelectors.selectLoadingUploadingState)
      .pipe(
        untilDestroyed(this),
        map((fn) => fn(this.pipeId))
      )
      .subscribe((status) => {
        this.isLoading = !!status;
      });

    this.store.select(MenuSelectors.selectErrorUploadingState)
      .pipe(
        untilDestroyed(this),
        map((fn) => fn(this.pipeId))
      )
      .subscribe((error) => {
        this.error = error;
      });

    this.menuOrganization$
      .pipe(
        untilDestroyed(this)
      )
      .subscribe(org => this.menuOrganization = org);

    this.past = this.lastSync ? getHumanizedPast(this.lastSync, this.translate.currentLang) : '';
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.past = changes.lastSync ? getHumanizedPast(changes.lastSync.currentValue as unknown as Date, this.translate.currentLang) : '';
  }

  // obsolete.
  handleSync(): void {
    if (!this.isLoading) {
      this.store.dispatch(MenuActions.setLoadingUploadingState([this.pipeId, true]));
      this.api.uploadMenu(this.pipeId)
        .subscribe({
          next: (response) => {
            if (!!response.error) {
              this.store.dispatch(MenuActions.setErrorUploadingState([this.pipeId, response.error.message]));
            } else {
              this.menuService.loadMenuSyncOfSales(this.menuOrganization.id).subscribe();
              this.menuService.loadMenuSyncOfPos(this.menuOrganization.id).subscribe();
            }
          },
          complete: () => {
            this.store.dispatch(MenuActions.setLoadingUploadingState([this.pipeId, false]));
          }
        });
    }
  }

  getSynchronizedText(): string {
    return this.translate.instant('MENU.SYNC.SYNCHRONIZED', {past: this.past});
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
  }
}
